import request from '@/api/request'

export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query,
  })
}
